var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.25,
    height: 12,
    viewBox: "0 0 11.25 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M169.7,24.081,173.883,19h-.992l-3.637,4.412L166.35,19H163l4.392,6.672L163,31h.992l3.841-4.659L170.9,31h3.35L169.7,24.081Zm-1.359,1.649-.445-.664L164.35,19.78h1.525l2.857,4.266.445.664,3.714,5.545h-1.524l-3.031-4.525Z",
    transform: "translate(-163 -19)",
    fill: "#9fa2a5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/X-icon.9b41d22c345f4c54be8871b597a3638d.svg";
export { ForwardRef as ReactComponent };